export default [
  {
    path: "/terms",
    component: () =>
      import(/* webpackChunkName: "terms" */ "@/views/global/Index"),
    children: [
      {
        path: "",
        name: "terms.index",
        meta: { layout: "HorizontalBar", hiddenAppBar: true },
        component: () =>
          import(/* webpackChunkName: "terms" */ "@/views/app/terms/Index"),
      },
      {
        path: "contract",
        name: "terms.contract",
        meta: { layout: "HorizontalBar", hiddenAppBar: true },
        component: () =>
          import(/* webpackChunkName: "terms" */ "@/views/app/terms/Contract"),
      },
      {
        path: "privacy",
        name: "terms.privacy",
        meta: { layout: "HorizontalBar", hiddenAppBar: true },
        component: () =>
          import(/* webpackChunkName: "terms" */ "@/views/app/terms/Privacy"),
      },
    ],
  },
];
